import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/** Layout-route wrapper for /admin — mirrors ProviderOnboardingGate's
 * pattern. The backend already enforces mandatory MFA at the API level
 * (get_current_user 403s on everything but /me, /auth/logout, /mfa/* for an
 * unenrolled super_admin/atuune_admin); this just avoids showing a page that
 * would otherwise render broken/empty from a wall of 403s, by sending the
 * account straight to Account Settings — where the Two-Factor Authentication
 * section (and only that section) actually matters — until it enrolls. */
export function RequireMfaEnrolled() {
  const { me } = useAuth()
  if (me?.mfa_enrollment_required) return <Navigate to="/account" replace />
  return <Outlet />
}
